import React, { useState } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import "../Poppup/popup.scss";

const CommonPopup = ({ handleChange, handleInputChange, inputValues, handleDeleteClick, type, businessType, prefix }) => {

  if (!inputValues || typeof inputValues !== 'object') {
    return null;
  }

  return (
    <div>
      {Object?.keys(inputValues).map((val) => {
        const data = inputValues[val];
        return (
          <div className="poupfourth_para" key={val}>
            <div className="poupcommercial">
              <div className="Popup_input">
                <div className="circlediv_s">
                  <span className="circle_dot"></span>
                  <span className="span_special_text">{data.label}</span>
                </div>
                <div style={{ cursor: "pointer" }} onClick={() => handleDeleteClick(val)}>
                  <img src={Image_Url.CROSSICONSRED}
                    className="crossiconred"
                    onClick={() => {
                      if (businessType) {
                        handleDeleteClick(businessType, val);
                      } else {
                        handleDeleteClick(val);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="inputdiv">
                <input
                  type="text"
                  className="input_filedspopup"
                  name={val}
                  value={data.value || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleInputChange(val, value, businessType);
                    handleChange( prefix ? prefix + data.label : val, prefix ? prefix + data.name : data.name, value, type);
                  }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CommonPopup;
